<script>
  import { Bar } from 'vue-chartjs'
  import chartRendererMixin from '@/components/elements/charts/chartRendererMixin'

  export default {
    extends: Bar,
    mixins: [chartRendererMixin]
  }
</script>



// WEBPACK FOOTER //
// BarChart.vue?e30f4d70